import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / ReadOnlyItemList`}</p>
    <h1 {...{
      "id": "class-readonlyitemlistt"
    }}>{`Class: ReadOnlyItemList<T`}{`>`}</h1>
    <p>{`ReadOnlyItemList represents an ordered list of API objects, representing items that are all children of the
same parent node. (The reverse is not necessarily true, however: this list might not include all
children that exist in the parent node. See `}<a parentName="p" {...{
        "href": "Node.md#allChildren"
      }}>{`allChildren`}</a>{` for details).`}</p>
    <p>{`Items in a bare ReadOnlyItemList cannot be added, removed, or reordered. Subclasses like ItemList may add these capabilities, however.`}</p>
    <h2 {...{
      "id": "type-parameters"
    }}>{`Type parameters`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`T`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`extends `}<a parentName="td" {...{
              "href": "../interfaces/ListItem.md"
            }}><inlineCode parentName="a">{`ListItem`}</inlineCode></a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`TemplatizedProxyLiveObject`}</inlineCode></p>
        <p parentName="li">{`↳ `}<strong parentName="p"><inlineCode parentName="strong">{`ReadOnlyItemList`}</inlineCode></strong></p>
        <p parentName="li">{`↳↳ `}<a parentName="p" {...{
            "href": "ArtboardList.md"
          }}><inlineCode parentName="a">{`ArtboardList`}</inlineCode></a></p>
        <p parentName="li">{`↳↳ `}<a parentName="p" {...{
            "href": "ItemList.md"
          }}><inlineCode parentName="a">{`ItemList`}</inlineCode></a></p>
        <p parentName="li">{`↳↳ `}<a parentName="p" {...{
            "href": "PageList.md"
          }}><inlineCode parentName="a">{`PageList`}</inlineCode></a></p>
      </li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "accessors"
    }}>{`Accessors`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ReadOnlyItemList.md#first"
        }}>{`first`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ReadOnlyItemList.md#last"
        }}>{`last`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ReadOnlyItemList.md#length"
        }}>{`length`}</a></li>
    </ul>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ReadOnlyItemList.md#%5Biterator%5D"
        }}>{`[iterator]`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ReadOnlyItemList.md#item"
        }}>{`item`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ReadOnlyItemList.md#toArray"
        }}>{`toArray`}</a></li>
    </ul>
    <h2 {...{
      "id": "accessors-1"
    }}>{`Accessors`}</h2>
    <h3 {...{
      "id": "a-idfirst-namefirsta-first"
    }}><a id="first" name="first"></a>{` first`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`first`}</strong>{`(): `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`T`}</inlineCode></p>
    <p>{`First item in this list, or undefined if list is empty.`}</p>
    <h4 {...{
      "id": "returns"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`T`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idlast-namelasta-last"
    }}><a id="last" name="last"></a>{` last`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`last`}</strong>{`(): `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`T`}</inlineCode></p>
    <p>{`Last item in this list, or undefined if list is empty.`}</p>
    <h4 {...{
      "id": "returns-1"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`T`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idlength-namelengtha-length"
    }}><a id="length" name="length"></a>{` length`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`length`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`Number of items in this list.`}</p>
    <h4 {...{
      "id": "returns-2"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h2 {...{
      "id": "methods-1"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "a-iditerator-nameiteratora-iterator"
    }}><a id="[iterator]" name="[iterator]"></a>{` `}{`[iterator]`}</h3>
    <p>{`▸ `}<strong parentName="p">{`[iterator]`}</strong>{`(): `}<inlineCode parentName="p">{`Iterator`}</inlineCode>{`<`}<inlineCode parentName="p">{`T`}</inlineCode>{`, `}<inlineCode parentName="p">{`any`}</inlineCode>{`, `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`>`}</p>
    <p>{`Iterates over all the items in this list. Mutations that occur mid-iteration are not reflected by the iterator.`}</p>
    <h4 {...{
      "id": "returns-3"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`Iterator`}</inlineCode>{`<`}<inlineCode parentName="p">{`T`}</inlineCode>{`, `}<inlineCode parentName="p">{`any`}</inlineCode>{`, `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`>`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-iditem-nameitema-item"
    }}><a id="item" name="item"></a>{` item`}</h3>
    <p>{`▸ `}<strong parentName="p">{`item`}</strong>{`(`}<inlineCode parentName="p">{`index`}</inlineCode>{`): `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`T`}</inlineCode></p>
    <p>{`Returns item at the given index, or undefined if index is out of range.`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`index`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Zero-based index`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-4"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`T`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idtoarray-nametoarraya-toarray"
    }}><a id="toArray" name="toArray"></a>{` toArray`}</h3>
    <p>{`▸ `}<strong parentName="p">{`toArray`}</strong>{`(): readonly `}<inlineCode parentName="p">{`T`}</inlineCode>{`[]`}</p>
    <p>{`All items in the list, as a static array. Mutations that occur later are not reflected in an array returned earlier.`}</p>
    <h4 {...{
      "id": "returns-5"
    }}>{`Returns`}</h4>
    <p>{`readonly `}<inlineCode parentName="p">{`T`}</inlineCode>{`[]`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      